import HeaderPortal from "components/portal/header-portal";
import { fetchFiles, fetchFolders } from "directus/src/operations";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AssetsGridItem from "./components/assets-grid-item";
import AssetsListItem from "./components/assets-list-item";
import FolderGridItem from "./components/folder-grid-item";
import FolderListItem from "./components/folder-list-item";
import ViewToggle from "./components/view-toggle";
import FolderGridSkeleton from "./components/folder-grid-skeleton";

export default function Folders() {

  const { "*": splat } = useParams();
  const folderPath = splat ? splat.split("/") : [];
  const currentFolderId =
    folderPath.length > 0
      ? folderPath[folderPath.length - 1]
      : import.meta.env.VITE_ASSETS_PARENT_FOLDER_ID;

  const [view, setView] = useState("grid");
  const [folders, setFolders] = useState(null);
  const [assets, setAssets] = useState(null);

  const fieldsMeta = {
    fields: ["id", "name", "parent"],
    filter: {
      parent: {
        _eq: currentFolderId
      }
    },
  };

  const getFolders = async () => {
    const folders = await fetchFolders(fieldsMeta);
    setFolders(folders);
  };

  const getAssets = async () => {
    const assets = await fetchFiles({
      fields: ["id", "title", "type", "filesize"],
      filter: {
        folder: {
          _eq: currentFolderId
        }
      }
    })
    setAssets(assets);
  }

  useEffect(() => {
    getFolders();
    getAssets();
  }, [currentFolderId]);

  return (
    <div className="w-full py-6">
      <HeaderPortal>
        <ViewToggle view={view} onViewChange={setView} />
      </HeaderPortal>

      <div className="px-4 py-4">
        <h2 className="text-2xl font-bold">Assets</h2>
      </div>

      {!folders && !assets && (
        <FolderGridSkeleton />
      )}

      {view === "grid" ? (
        <div className="px-4 grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-5 xl:grid-cols-6">
          <>
            {folders && folders.map((folder) => {
              return <FolderGridItem key={folder.id} folder={folder} />
            })}
            {assets && assets.map((asset) => {
              return <AssetsGridItem key={asset.id} asset={asset} />
            })}
          </>
        </div>
      ) : (
        <div className="px-4 rounded-lg overflow-hidden">
          {folders && folders.map((folder) => {
            return <FolderListItem key={folder.id} folder={folder} />;
          })}
          {assets && assets.map((asset) => {
            return <AssetsListItem key={asset.id} asset={asset} />
          })}
        </div>
      )}
    </div>
  );
}
